import fa from './fa'
import i18n from '../i18n'
export default {
  _default: function (fieldName) {
    return i18n.t('validations.messages._default', {
      fieldName: i18n.t(fieldName)
    })
  },
  after: function (fieldName, params) {
    return i18n.t('validations.messages.after', {
      fieldName: i18n.t(fieldName),
      param1: params[0]
    })
  },
  alpha: function (fieldName) {
    return i18n.t('validations.messages.alpha', {
      fieldName: i18n.t(fieldName)
    })
  },
  alpha_dash: function (fieldName) {
    return i18n.t('validations.messages.alpha_dash', {
      fieldName: i18n.t(fieldName)
    })
  },
  alpha_num: function (fieldName) {
    return i18n.t('validations.messages.alpha_num', {
      fieldName: i18n.t(fieldName)
    })
  },
  alpha_spaces: function (fieldName) {
    return i18n.t('validations.messages.alpha_spaces', {
      fieldName: i18n.t(fieldName)
    })
  },
  before: function (fieldName, params) {
    return i18n.t('validations.messages.before', {
      fieldName: i18n.t(fieldName),
      param1: params[0]
    })
  },
  between: function (fieldName, params) {
    return i18n.t('validations.messages.between', {
      fieldName: i18n.t(fieldName),
      param1: params[0],
      param2: params[1]
    })
  },
  confirmed: function (fieldName) {
    return i18n.t('validations.messages.confirmed', {
      fieldName: i18n.t(fieldName)
    })
  },
  credit_card: function (fieldName) {
    return i18n.t('validations.messages.credit_card', {
      fieldName: i18n.t(fieldName)
    })
  },
  date_between: function (fieldNamen, params) {
    return i18n.t('validations.messages.date_between', {
      fieldName: i18n.t(fieldName),
      param1: params[0],
      param2: params[1]
    })
  },
  date_format: function (n, e) {
    return i18n.t('validations.messages.date_format', {
      fieldName: i18n.t(fieldName),
      param1: params[0]
    })
  },
  decimal: function (n, e) {
    void 0 === e && (e = [])
    var t = e[0]
    return (
      void 0 === t && (t = '*'),
      n +
        ' باید یک مقدار عددی ' +
        (t === '*' ? '' : ' با حداکثر ' + t + ' اعشار') +
        ' باشد.'
    )
  },
  digits: function (fieldName, params) {
    return i18n.t('validations.messages.digits', {
      fieldName: i18n.t(fieldName),
      param1: params[0]
    })
  },
  dimensions: function (fieldName, params) {
    return i18n.t('validations.messages.dimensions', {
      fieldName: i18n.t(fieldName),
      param1: params[0],
      param2: params[1]
    })
  },
  email: function (fieldName) {
    return i18n.t('validations.messages.email', {
      fieldName: i18n.t(fieldName)
    })
  },
  excluded: function (fieldName) {
    return i18n.t('validations.messages.excluded', {
      fieldName: i18n.t(fieldName)
    })
  },
  ext: function (fieldName) {
    return i18n.t('validations.messages.ext', {
      fieldName: i18n.t(fieldName)
    })
  },
  image: function (fieldName) {
    return i18n.t('validations.messages.image', {
      fieldName: i18n.t(fieldName)
    })
  },
  included: function (fieldName) {
    return i18n.t('validations.messages.included', {
      fieldName: i18n.t(fieldName)
    })
  },
  ip: function (fieldName) {
    return i18n.t('validations.messages.ip', {
      fieldName: i18n.t(fieldName)
    })
  },
  max: function (fieldName, params) {
    return i18n.t('validations.messages.max', {
      fieldName: i18n.t(fieldName),
      param1: params[0]
    })
  },
  max_value: function (fieldName, params) {
    return i18n.t('validations.messages.max_value', {
      fieldName: i18n.t(fieldName),
      param1: params[0]
    })
  },
  mimes: function (fieldName) {
    return i18n.t('validations.messages.mimes', {
      fieldName: i18n.t(fieldName)
    })
  },
  min: function (fieldName, params) {
    return i18n.t('validations.messages.min', {
      fieldName: i18n.t(fieldName),
      param1: params[0]
    })
  },
  min_value: function (fieldName, params) {
    return i18n.t('validations.messages.min_value', {
      fieldName: i18n.t(fieldName),
      param1: params[0]
    })
  },
  numeric: function (fieldName) {
    return i18n.t('validations.messages.numeric', {
      fieldName: i18n.t(fieldName)
    })
  },
  regex: function (fieldName) {
    return i18n.t('validations.messages.regex', {
      fieldName: i18n.t(fieldName)
    })
  },
  required: function (fieldName) {
    var x = i18n.t('validations.messages.required', {
      fieldName: i18n.t(fieldName)
    })
    return x
  },
  size: function (fieldName, params) {
    var t = params[0]
    return i18n.t('validations.messages.size', {
      fieldName: i18n.t(fieldName),
      param1: r(t)
    })
  },
  url: function (fieldName) {
    return i18n.t('validations.messages.url', {
      fieldName: i18n.t(fieldName)
    })
  }
}
